import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/AppLayout";
import KnowledgeDetail from "../components/KnowledgeDetail";
import { HelpCircle, Lock } from "lucide-react";

export default function OpenQuestions() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => { api.get("/knowledge?type=OPEN_QUESTION").then((r) => setItems(r.data)); }, []);

  const openCount = items.filter((it) => it.status === "OPEN").length;

  return (
    <div>
      <PageHeader
        title="Open Questions"
        subtitle={`Formally unresolved matters. PRAMAANA must never fabricate a settled answer where an open question governs. Resolved / locked questions are preserved for history.`}
      />
      <div className="p-10">
        <div
          className="mb-6 text-sm text-slate-600 font-mono"
          data-testid="open-questions-count"
        >
          Open: <span className="text-blue-800 font-semibold">{openCount}</span>
          <span className="mx-2 text-slate-300">|</span>
          Total including resolved: <span className="text-slate-800 font-semibold">{items.length}</span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="open-questions-list">
          {items.map((it, i) => {
            const isResolved = it.status && it.status !== "OPEN";
            const containerCls = isResolved
              ? "text-left bg-emerald-50/40 border border-emerald-300 p-6 hover:border-emerald-500 transition-colors duration-150 fade-in"
              : "text-left bg-blue-50/40 border border-blue-200 p-6 hover:border-blue-400 transition-colors duration-150 fade-in";
            const idBadgeCls = isResolved
              ? "font-mono text-sm text-emerald-800 bg-emerald-100 px-2 py-0.5 rounded-sm"
              : "font-mono text-sm text-blue-800 bg-blue-100 px-2 py-0.5 rounded-sm";
            const statusBadgeCls = isResolved
              ? "font-mono text-[11px] uppercase tracking-wider text-emerald-800 bg-emerald-100 border border-emerald-300 px-2 py-0.5 rounded-sm ml-auto flex items-center gap-1"
              : "font-mono text-[11px] uppercase tracking-wider text-blue-700 ml-auto";
            const Icon = isResolved ? Lock : HelpCircle;
            const iconCls = isResolved ? "text-emerald-700" : "text-blue-700";
            return (
              <button
                key={it.id}
                data-testid={`open-question-${it.knowledge_id}`}
                data-status={it.status}
                onClick={() => setSelected(it.id)}
                className={containerCls}
                style={{ animationDelay: `${i * 8}ms` }}
              >
                <div className="flex items-center gap-3 mb-3">
                  <Icon size={18} className={iconCls} />
                  <span className={idBadgeCls}>{it.knowledge_id}</span>
                  <span className={statusBadgeCls}>
                    {isResolved ? (<><Lock size={11} /> Resolved / Locked</>) : "Unresolved"}
                  </span>
                </div>
                <h3 className="font-sans font-semibold text-slate-800 mb-1">{it.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{it.statement}</p>
              </button>
            );
          })}
        </div>
      </div>
      <KnowledgeDetail itemId={selected} open={!!selected} onClose={() => setSelected(null)} />
    </div>
  );
}
